import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';

/** Any workflow builder (legacy or V2) that can report unsaved edits. */
interface UnsavedDataAware {
  hasUnsavedData(): boolean
}

@Injectable({
  providedIn: 'root'
})
export class WorkflowUnsavedDataGuard  {
  canDeactivate(
    component: UnsavedDataAware,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (component.hasUnsavedData()) {
      return confirm("You are about to leave this page. Unsaved changes will be lost. Are you sure?")
    }
    return true
  }

}
